<template>
  <div class="cover-content table-wrapper">
    <Form ref="formInline" :model="formInline" inline class="form-list" :label-width="100" label-position="right">
      <div>
        <FormItem label="姓名:" prop="workerName" style="width:286px;text-align:left;">
          <Input v-model="formInline.workerName" style="width: 200px" placeholder="请输入人员姓名"></Input>
        </FormItem>
        <FormItem label="退场日期:" prop="date" style="width:286px;text-align:left;">
          <Date-picker 
            :value="formInline.date"
            type="date" 
            format="yyyy-MM-dd" 
            placeholder="请选择退场日期"
            @on-change="formInline.date=$event"></Date-picker>
        </FormItem>
        <Button style="margin-left: 15px;float:right;" @click="handleReset">重置</Button>
        <Button style="float:right;" type="primary" @click="handleQuery">搜索</Button>
      </div>
    </Form>
    <div class='cover-table'>
      <Table style="width: 100%;" max-height='520' :loading="loading" border :columns="tableColumns" :data="tableData" highlight-row>
        <template slot-scope="{ row, index }" slot="workerName">
          <span class="pointer"  @click.stop="handleDetail('exitRecordDetail', row.workerId)">{{row.workerName}}</span>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <span class="pointer"  @click.stop="handleDeal(row.projectWorkerId)">查看</span>
        </template>
      </Table>
      <Page class='page' :total="totalCount" :page-size="pageSize" :current="page" @on-change="changePage" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total transfer>
      </Page>
    </div>
    <Modal v-model="allModel" footer-hide width="1400">
      <p slot="header">
          <span>工资发放记录</span>
      </p>
      <div style="display: flex;justify-content: space-between;margin-bottom: 15px;">
        <div>姓名：<span>{{payroll.workerName}}</span></div>
        <div>身份证号：<span>{{payroll.idCardNumber}}</span></div>
        <div>项目：<span>{{payroll.projectName}}</span></div>
        <div>班组：<span>{{payroll.teamName}}</span></div>
        <div>工种：<span>{{payroll.workType}}</span></div>
        <div>进场日期：<span>{{payroll.entryDate}}</span></div>
        <div>退场日期：<span>{{payroll.exitDate}}</span></div>
      </div>
      <Table border size="small" :loading="loading" :columns="allColumns" :data="allData" highlight-row></Table>
      <div class="t-page">
        <Page :total="totalCount1" :page-size="pageSize1" :current="page1"
              @on-change="changePage1" @on-page-size-change="pageSizeChange"
              show-elevator show-sizer show-total transfer>
        </Page>
      </div>
    </Modal>
  </div>
</template>
<style scoped>

</style>
<script>
    import { mapState } from 'vuex';
    import tableMixin from '@/components/tableMixin';

    export default {
        mixins: [tableMixin],
        data(){
          return {
              allModel: false,
              formInline:{
                workerName: '',
                areaCode: localStorage.getItem('tenantAreaCode'),
                date: ''
              },
              tableColumns:[
                  { title: '序号', type: 'index', width: 70, align: 'center' },
                  { title: '姓名', slot: 'workerName',width: 80, align: 'center' },
                  { title: '身份证', key: 'idCardNumber', align: 'center' },
                  { title: '年龄', key: 'age', width: 60,align: 'center' },
                  { title: '项目', key: 'projectName', align: 'center' },
                  { title: '班组', key: 'teamName', align: 'center' },
                  { title: '工种', key: 'workType', align: 'center' },
                  { title: '进场日期', key: 'entryDate', align: 'center' },
                  { title: '退场日期', key: 'exitDate', align: 'center' },                 
                  { title: '工资发放时间', key: 'payOffDate', align: 'center' },
                  { title: '工资发放记录', slot: 'action', align: 'center' }
              ],
              allColumns:[
                  { title: '序号', type: 'index', width: 50, align: 'center' },
                  { title: '工资月份', key: 'payMonth', align: 'center' },
                  { title: '出勤天数（天）', key: 'attendanceDays', align: 'center' },
                  { title: '总工时（小时）', key: 'workHours', align: 'center' },
                  { title: '应发金额（元）', key: 'totalPayAmount', align: 'center' },
                  { title: '实发金额（元）', key: 'actualAmount', align: 'center' },
                  { title: '是否补发', key: 'isBackPay', align: 'center' },
                  { title: '发放日期', key: 'balanceDate', align: 'center' },
                  { title: '补发月份', key: 'backPayMonth', align: 'center' },                 
                  { title: '工人工资卡号', key: 'payBankCardNumber', align: 'center' },
                  { title: '工人工资卡开户名称', key: 'payRollBankName', align: 'center' },
                  { title: '工资代发银行卡号', key: 'payBankCardNumber', align: 'center' },
                  { title: '工人工资卡开户名称', key: 'payBankName', align: 'center' }
              ],
              tableData: [],
              allData: [],
              payroll: [],
              totalCount1: 0,
              ayrollPid: '',
              pageSize1: 10,
              page1: 1
          }
        },
        computed:{
          ...mapState(['navList','area','citys'])
        },
        created(){

        },
        mounted(){

        },
        watch: {

        },
        methods: {
          handleDetail (name,uuid) {
            this.$router.push({
              name: name,
              query: {
                  workerId:uuid
              }
            });
          },
          handleReset() {
            this.page = 1
            this.pageSize = 10;
            this.formInline.date = ''
            this.formInline.workerName = ''
            this.getTableData()
          },
          //分页切换
          changePage(value) {
            this.page = value
            this.formInline.current = value;
            this.getTableData()
          },
          changePage1(value) {
            this.page1 = value
            this.payrollRecords()
          },
          /*处理操作*/
          handleDeal(pid){
            this.page1 = 1
            this.pageSize1 = 10;
            this.ayrollPid = pid
            this.allModel = true
            this.axios({
                method: 'get',
                url: '/worker/workerExitRecord',
                params: {
                  projectWorkerId: pid, 
                }
            }).then( (response)=> {
                this.loading=false;
                if (response.data.success){
                    this.payroll = response.data.data;
                }
            }).catch( ()=> {
                this.loading=false;
            });
            this.payrollRecords()
          },
          payrollRecords() {
            this.axios({
                  method: 'get',
                  url: '/worker/workerPayRollList',
                  params: {
                    projectWorkerId: this.ayrollPid, 
                    pageNo:this.page, 
                    pageSize:this.pageSize, 
                  }
              }).then( (response)=> {
                  this.loading=false;
                  if (response.data.success){
                      this.totalCount1 = response.data.data.total;
                      this.allData = response.data.data.records;
                  }
              }).catch( ()=> {
                  this.loading=false;
              });
          },
          /*获取表格数据*/
          getTableData(){
              const { areaCode, workerName, date} = this.formInline
              this.loading=true;
              this.axios({
                  method: 'get',
                  url: '/worker/workerExitList',
                  params: {
                    areaCode, 
                    pageNo:this.page, 
                    pageSize:this.pageSize, 
                    workerName,
                    date
                  }
              }).then( (response)=> {
                  this.loading=false;
                  if (response.data.success){
                      this.totalCount = response.data.data.total;
                      this.tableData = response.data.data.records;
                  }
              }).catch( ()=> {
                  this.loading=false;
              });
          },
      }
    };
</script>
